import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav';
function Cart() {
  return (
    <>
      <Nav />
      <div className="container mx-auto  bg-gray-50 text-gray-600 pb-20">
        <section className="relative block h-[500px]">
          <img
            src="banner.png"
            className="absolute top-0 w-full h-full bg-center bg-cover"
            alt=""
          />

          <span
            id="blackOverlay"
            className="w-full h-full absolute opacity-20 bg-black"
          ></span>
        </section>

        <section className="bg-gray-100">
          <div className="container mx-auto px-4 ">
            <div className="relative flex flex-col min-w-0 break-words bg-gray-50 w-full mb-6 shadow-xl rounded-lg -mt-64">
              <div className="container mx-auto">
                <div className="py-10 container mx-auto mb-20 sm:mx-auto text-justify bg-gray-100 rounded-md p-8">
                  <h1 className="font-bold text-3xl mb-10 justify-center text-center  text-yellow-700">
                    My Cart{' '}
                  </h1>
                  <div className="w-full flex flex-col lg:flex-row">
                    <div className="max-w-xl mx-auto">
                      <h1 className="font-bold text-2xl border-b-2 border-yellow-700 text-yellow-700 text-center">
                        SELECTED ITEMS
                      </h1>
                      <div className="flex flex-row">
                        <img src="belt3.jpg" className="w-12 h-12 m-3" alt="" />
                        <span className="m-3">Beautiful Belt</span>
                        <span className="m-3">12 Pcs</span>
                        <span className="m-3">12 * 120.00</span>
                      </div>
                      <div className="flex flex-row">
                        <img src="belt3.jpg" className="w-12 h-12 m-3" alt="" />
                        <span className="m-3">Beautiful Belt</span>
                        <span className="m-3">12 Pcs</span>
                        <span className="m-3">12 * 120.00</span>
                      </div>
                      <div className="flex flex-row">
                        <img src="belt3.jpg" className="w-12 h-12 m-3" alt="" />
                        <span className="m-3">Beautiful Belt</span>
                        <span className="m-3">12 Pcs</span>
                        <span className="m-3">12 * 120.00</span>
                      </div>
                      <div className="flex flex-row">
                        <img src="belt3.jpg" className="w-12 h-12 m-3" alt="" />
                        <span className="m-3">Beautiful Belt</span>
                        <span className="m-3">12 Pcs</span>
                        <span className="m-3">12 * 120.00</span>
                      </div>
                    </div>

                    <div className="max-w-xl flex flex-col justify-between mx-auto">
                      <div className="flex flex-col font-semibold capitalize  tracking-widest">
                        <h1 className="font-bold text-2xl uppercase border-b-2 border-yellow-700 mb-4 text-yellow-700">
                          Checkout
                        </h1>
                        <span className="mb-1">Quantity: 48 items</span>
                        <span className="mb-1">Tax: 4.5%</span>
                        <span className="mb-1">
                          (Total price) - (Tax): 1400-200{' '}
                        </span>
                        <span className="mb-1">Grand total: GHc 1200.00</span>
                      </div>
                      <div className=" max-w-xl">
                        <Link to="/order">
                          <span className="bg-yellow-500 rounded-full px-16 max-w-xl uppercase py-3 text-white shadow-md ">
                            Check OUt
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Cart;
